// ====================================================
// src/components/block/liveStreamManagement/enchainements/PousseEnchainement.tsx
//
// Le flux "final" actuel est poussé hors cadre dans la direction choisie,
// le flux "preview" entre par le côté opposé — les deux glissent ensemble,
// comme une bande continue. Direction réglable via DirectionPicker.
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';
import { DirectionConfig, DEFAULT_DIRECTION_CONFIG, directionOffset } from './directionUtils';
import DirectionPicker from './DirectionPicker';

class PousseEnchainementImpl extends Enchainement<DirectionConfig> {
  readonly id = 'pousse';
  readonly label = 'Poussé';
  readonly icon = 'ArrowRightCircle';
  readonly defaultConfig: DirectionConfig = DEFAULT_DIRECTION_CONFIG;

  render(input: EnchainementRenderInput, config: DirectionConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;
    const { x: ox, y: oy } = directionOffset(config.angleDeg, width, height);

    // Le sortant continue son chemin dans le sens du mouvement.
    ctx.save();
    ctx.translate(progress * ox, progress * oy);
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);
    ctx.restore();

    // L'entrant démarre décalé d'un plein cadre en arrière, arrive à (0,0).
    ctx.save();
    ctx.translate(progress * ox - ox, progress * oy - oy);
    ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
    ctx.restore();
  }

  renderControls({ config, onChange }: EnchainementControlProps<DirectionConfig>): React.ReactNode {
    return (
      <DirectionPicker
        angleDeg={config.angleDeg}
        onChange={angleDeg => onChange({ angleDeg })}
      />
    );
  }
}

export const pousseEnchainement = new PousseEnchainementImpl();
